/**
 * Узел Group (архиматная группа без иконки, path из getGroupingPath).
 */
import ArchimateNodeType from '../ArchimateNodeType';
import {getGroupingPath, resolveGroupingTabBox} from '@core_x6/lib';
import {MIN_GROUP_ELEMENT_HEIGHT} from '@core_x6/lib/modelerX6/constants';
import {ARCHIMATE_GROUP} from '../../metamodel/Concept';
import {textAlignToLabelAttrs} from '../textAlignUtil';

const DEFAULT_SIZE = {width: 120, height: MIN_GROUP_ELEMENT_HEIGHT};

export default class GroupNodeType extends ArchimateNodeType {
	static get typeName() {
		return ARCHIMATE_GROUP;
	}

	get shapeId() {
		return 'archimate:group';
	}

	get defaultSize() {
		return DEFAULT_SIZE;
	}

	canConnectTo() {
		return true;
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor, textAlign} = options;
		// Как у Note: подпись в язычке слева; дефолт center-top (refX: 0.5) визуально «толкает» текст
		// в центр всего bbox, хотя тело группы визуально слева — отсюда лишние «поля».
		const align = textAlignToLabelAttrs(textAlign, {
			defaultHorizontal: 'left',
			defaultVertical: 'top',
		});
		const w = width ?? DEFAULT_SIZE.width;
		const h = height ?? DEFAULT_SIZE.height;
		const tabBox = resolveGroupingTabBox({
			width: w,
			height: h,
			label: label ?? '',
			textVerticalAnchor: align.textVerticalAnchor,
			reserveForIcon: false,
		});
		const groupPath = getGroupingPath({width: w, height: h}, tabBox);
		const nodeAttrs = {
			body: {
				d: groupPath,
				fill: fillColor ?? '#c0c0c0',
				stroke: lineColor ?? '#585858',
				strokeWidth: 1,
			},
			label: {
				text: label ?? '',
				...align,
				refWidth: -16,
				refHeight: -16,
				textWrap: {width: '100%', height: '100%', ellipsis: true, breakWord: true},
			},
		};
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
		};
	}
}
